import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { getAccountScopeUserSettings } from 'owa-session-store';
import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/Store';
import { getMLColumnHeaderDefaultWidths } from '../utils/getMLColumnHeaderDefaultWidths';
import { getItem } from 'owa-local-storage';
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
const initializeListViewColumnWidths: () => void = mutatorAction(
    'initializeListViewColumnWidths',
    (): void => {
        const {
            senderColumnWidth,
            subjectColumnWidth,
            receivedColumnWidth,
            sortedContentColumnWidth,
        } = getListViewColumnWidthSettings();
        getStore().senderColumnWidth = senderColumnWidth;
        getStore().subjectColumnWidth = subjectColumnWidth;
        getStore().receivedColumnWidth = receivedColumnWidth;
        getStore().sortedContentColumnWidth = sortedContentColumnWidth;
    }
);
/**
 * This function gets the default ML column width header values to render with
 * at boot. The value will be from local storage (previous session's column widths),
 * OWS' settings, or the default values (in the case where the user hasn't modified
 * the column widths yet).
 *
 * Note that we're getting these values from the UserConfiguration object instead
 * of from the "owa-outlook-service-options" package for boot bundle size health.
 */
const getListViewColumnWidthSettings = () => {
    const previouslySavedColumnWidths = getPreviouslySavedColumnWidths();
    if (previouslySavedColumnWidths) {
        return previouslySavedColumnWidths;
    }
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    const primeSettingsItems = getAccountScopeUserSettings(mailboxInfo)?.PrimeSettings?.Items;
    const primeListViewColumnHeadersOptions: any[] | undefined = primeSettingsItems?.filter(
        item => item?.Id == 'ListViewColumnHeadersOptions'
    );
    const listViewColumnHeadersWidths = primeListViewColumnHeadersOptions?.[0]?.Value?.options?.[0];
    const defaultWidths = getMLColumnHeaderDefaultWidths();

    return {
        senderColumnWidth:
            listViewColumnHeadersWidths?.senderColumnWidth || defaultWidths.senderColumnWidth,
        subjectColumnWidth:
            listViewColumnHeadersWidths?.subjectColumnWidth || defaultWidths.subjectColumnWidth,
        receivedColumnWidth:
            listViewColumnHeadersWidths?.receivedColumnWidth || defaultWidths.receivedColumnWidth,
        sortedContentColumnWidth: 0, // Zero as this is not a permanent column
    };
};
export default initializeListViewColumnWidths;
const getPreviouslySavedColumnWidths = () => {
    const previousColumnWidthValues = getItem(window, 'MailListColumnWidths');
    if (previousColumnWidthValues) {
        const parsedPreviousColumnWidthValues = JSON.parse(previousColumnWidthValues);
        return {
            senderColumnWidth: parsedPreviousColumnWidthValues.senderColumnWidth,
            subjectColumnWidth: parsedPreviousColumnWidthValues.subjectColumnWidth,
            receivedColumnWidth: parsedPreviousColumnWidthValues.receivedColumnWidth,
            sortedContentColumnWidth: parsedPreviousColumnWidthValues.sortedContentColumnWidth ?? 0,
        };
    }
    return null;
};
